import { makeStyles } from "@material-ui/core";

export const useCardWidgetStyles = makeStyles((theme) => ({
    container: {
        alignSelf: "start",
        minWidth: "180px",
        minHeight: "80px",

        padding: "20px 28px",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "stretch",

        backgroundColor: theme.palette.background.paper,
        border: `1.5px solid ${theme.palette.divider}`,
        borderRadius: "16px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
        transition: "box-shadow 0.2s ease",

        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        },
    },
    summary: {
        flexGrow: 1,
        display: "grid",
        gridTemplateColumns: "1fr 0.5fr",
        gap: "8px",
        alignItems: "end",
    },
    icon: {
        fontSize: "54px",
        color: theme.palette.primary.main,
    },
    descr: {
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.06em",
        textTransform: "uppercase" as const,
        width: "90px",
        color: theme.palette.text.secondary,
        lineHeight: 1.3,
    },
}));
